import store from '../store'
import setLoggedUser from './set-logged-user'
import logout from './logout'

/**
 * Send refresh token saved in local store
 *
 * @param {string|null} refreshToken
 * @return {axios}
 */
export default (refreshToken = null) => {
    store.dispatch({
        type: 'TOGGLE_BUSY_SECTION',
        section: 'login',
    })

    const json = {
        grant_type: 'refresh_token',
        client_id: window.APP_CONFIG.REACT_APP_BACKEND_AUTH_ID,
        client_secret: window.APP_CONFIG.REACT_APP_BACKEND_AUTH_SECRET,
        refresh_token: refreshToken || (localStorage.getItem('sportnect.tokens') && localStorage.getItem('sportnect.tokens') !== 'undefined' ? JSON.parse(localStorage.getItem('sportnect.tokens')).refresh_token : null),
    }

    window.axios.defaults.headers.common.Authorization = ''

    const defaultHeaders = {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
        },
    }

    return window.axios.post(`${window.APP_CONFIG.REACT_APP_API_URL}api/oauth/token`, json, defaultHeaders)
        .then(({ data }) => (
            setLoggedUser(data, false, true)
                .then(() => new Promise(resolve => resolve(data)))
        )).catch(err => {
            if (err.response) {
                store.dispatch({
                    type: 'SET_LOGIN_ERROR',
                    error: err.response.data.error,
                })
                logout()
            }

            store.dispatch({
                type: 'TOGGLE_BUSY_SECTION',
                section: 'login',
            })
        })
}
